import cn from "classnames";

import { NAVIGATION_GROUP_TYPE } from "@/app/blu/shop/constants";
import type { GetNavigationQueryResult } from "@/sanity.types";

import {
  HeaderMegaMenuFeaturedItem,
  type HeaderMegaMenuFeaturedItemProps,
} from "./headerMegaMenuFeaturedItem.component";
import type { NavigationMenuGroupItem } from "./navigationQuery.types";

export const HeaderMobileFeaturedProducts = ({
  menu,
}: HeaderMobileFeaturedProductsProps) => {
  const renderFeaturedProducts = () => {
    if (!menu?.items?.length) return null;
    const featuredItems = menu.items
      .filter(
        (item): item is NavigationMenuGroupItem =>
          item._type === NAVIGATION_GROUP_TYPE,
      )
      .flatMap((item) => item.featuredItems ?? []);
    if (!featuredItems.length) return null;
    return featuredItems.map((nav, index) => {
      if (!nav?.link?.url) return null;
      return (
        <HeaderMegaMenuFeaturedItem
          item={nav as HeaderMegaMenuFeaturedItemProps["item"]}
          key={nav._key}
          className={cn({
            "col-span-2": index == 0,
          })}
          linkClassName={cn({
            "flex-row": index == 0,
          })}
        />
      );
    });
  };
  return (
    <nav data-testid="header-mobile-featured-products" className="px-4 py-6">
      <ul
        data-testid="header-mobile-featured-products-list"
        className="grid grid-cols-2 gap-4">
        {renderFeaturedProducts()}
      </ul>
    </nav>
  );
};

export type HeaderMobileFeaturedProductsProps = {
  menu?: GetNavigationQueryResult;
};
